import { render, staticRenderFns } from "./NewProducts.vue?vue&type=template&id=e842804c"
import script from "./NewProducts.vue?vue&type=script&lang=js"
export * from "./NewProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports